import React from "react";
import { ArrowSmallIcon } from "../icons";

export default function SelectCard({ title, subtitle, icon, selected, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "group relative w-full overflow-hidden rounded-2xl border bg-white p-5 text-left shadow-sm transition",
        "hover:-translate-y-0.5 hover:shadow-md",
        selected ? "border-emerald-400 ring-4 ring-emerald-500/10" : "border-gray-200",
      ].join(" ")}
    >
      <div className="pointer-events-none absolute inset-0 opacity-0 transition group-hover:opacity-100 bg-gradient-to-br from-emerald-500/10 via-transparent to-lime-500/10" />

      <div className="relative flex items-start gap-4">
        <div
          className={[
            "flex h-12 w-12 items-center justify-center rounded-2xl ring-1",
            selected
              ? "bg-[#0b2b40] text-white ring-emerald-600"
              : " text-[#8ec700] ring-[#cac6c6]",
          ].join(" ")}
        >
          {icon}
        </div>

        <div className="min-w-0">
          <div className="text-base font-semibold text-slate-900">{title}</div>
          <div className="mt-1 text-sm text-slate-600">{subtitle}</div>

          <div className="mt-3 inline-flex items-center gap-2 text-xs font-semibold text-[#8ec700]">
            Auswählen <ArrowSmallIcon />
          </div>
        </div>
      </div>
    </button>
  );
}
